export enum DesktopProcessActions {
    clearHolter = 'clearHolter',
    configureHolter = 'configureHolter',
    detectHolter = 'detectHolter',
    readHolter = 'readHolter',
    restEcg_procedure_cardioPerfect = 'restEcg_procedure_cardioPerfect',
    restEcg_request_cardioPerfect = 'restEcg_request_cardioPerfect',
    spirometry_procedure_cardioPerfect = 'spirometry_procedure_cardioPerfect',
    spirometry_procedure_careFusion = 'spirometry_procedure_careFusion',
    spirometry_request_cardioPerfect = 'spirometry_request_cardioPerfect',
    spirometry_request_careFusion = 'spirometry_request_careFusion',
}
